import { ChevronDown } from 'lucide-react'
import CommonModal from '../common/modal/CommonModal'
import { useState } from 'react'

interface IChatExitModalProps {
  showExitModal: boolean
  handleClose: () => void
  handleConfirmExit: (skip: boolean) => void
  selectedReason: string
  setSelectedReason: (selectedReason: string) => void
  // customReason: string
  // setCustomReason: (customReason: string) => void
  reasons: { value: string; label: string }[]
  hasReason: boolean
  isLoading?: boolean
}

const ChatExitModal = ({
  handleClose,
  handleConfirmExit,
  selectedReason,
  setSelectedReason,
  // customReason,
  // setCustomReason,
  reasons,
  hasReason,
  isLoading = false
}: IChatExitModalProps) => {
  const [buttonState, setButtonState] = useState<'yes' | 'no' | null>(null)

  return (
    <CommonModal
      onClose={handleClose}
      title={
        <>
          <span className='text-amber-900 text-[16px]'>진행중인 상담이 종료됩니다.</span>
          <br />
          <span className='text-amber-900 text-[16px] text-nowrap'>이 주제의 상담을 다시 진행하시겠습니까?</span>
        </>
      }
      topButtonText='종료하기'
      topButtonOnClick={() => {
        if (!buttonState) return
        // buttonState가 'yes'면 skip=false (다시 상담 진행)
        // buttonState가 'no'면 skip=true (상담 종료)
        handleConfirmExit(buttonState === 'no')
      }}
      isTopButtonDisabled={
        isLoading ||
        (buttonState === 'yes'
          ? false
          : hasReason && buttonState === 'no'
            ? !selectedReason.length
            : buttonState === null)
      }
      modalContent={
        <div className='mb-6'>
          <div className='flex justify-between gap-4 mb-4'>
            <button
              className={`w-1/2  text-amber-900 py-3 px-4 rounded-lg leading-tight focus:outline-none  text-sm ${
                buttonState === 'yes'
                  ? 'bg-gradient-to-r from-amber-400 to-amber-600 text-white'
                  : 'bg-amber-100 text-amber-400'
              }`}
              onClick={() => setButtonState('yes')}
            >
              네
            </button>
            <button
              className={`w-1/2    text-amber-900 py-3 px-4 rounded-lg leading-tight focus:outline-none text-sm ${
                buttonState === 'no'
                  ? 'bg-gradient-to-r from-amber-400 to-amber-600 text-white'
                  : 'bg-amber-100 text-amber-400'
              }`}
              onClick={() => setButtonState('no')}
            >
              아니오
            </button>
          </div>
          <div className='relative'>
            {hasReason && buttonState === 'no' && (
              <>
                <select
                  value={selectedReason}
                  onChange={e => {
                    setSelectedReason(e.target.value)
                  }}
                  className='w-full appearance-none bg-amber-50 border border-amber-200 text-amber-900 py-3 px-4 pr-8 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-amber-500 text-sm'
                >
                  <option value='' disabled>
                    종료 사유를 선택해 주세요!
                  </option>
                  {reasons.map(reason => (
                    <option key={reason.value} value={reason.value}>
                      {reason.label}
                    </option>
                  ))}
                </select>
                <div className='pointer-events-none absolute inset-y-0 right-0 flex items-center px-3 text-amber-700'>
                  <ChevronDown size={18} />
                </div>
              </>
            )}
          </div>
          {/* {buttonState === 'no' && selectedReason === 'other' && (
            <input
              type='text'
              value={customReason}
              onChange={e => setCustomReason(e.target.value)}
              placeholder='종료 사유를 입력해 주세요'
              className='w-full mt-3 bg-amber-50 border border-amber-200 text-amber-900 py-3 px-4 rounded-lg leading-tight focus:outline-none focus:bg-white focus:border-amber-500 text-sm'
            />
          )} */}
        </div>
      }
    />
  )
}

export default ChatExitModal
